/**
 * JSON Parse Utilities
 * Issue #2074,#2075,#2071: 統一されたJSONパースエラーハンドリング
 *
 * response.json()の失敗（パースエラー・ボディ読み取りエラー等）を統一的に処理する薄いユーティリティ。
 * DRYの原則に従い、繰り返しの`.catch()`パターンを1箇所に集約。
 */

import logger from './logger';

/**
 * response.json()をsafeにパースし、エラー時はデフォルト値を返す
 *
 * @param response - Fetchレスポンスオブジェクト
 * @param context - エラーログに含めるコンテキスト文字列
 * @param fallback - パース失敗時のフォールバック値（デフォルトは空オブジェクト）。
 *   注意: デフォルトの `{}` は `T` の必須フィールドを含まない。
 *   型安全性が必要な場合は明示的にフォールバック値を渡すこと。
 * @returns パース済みデータまたはフォールバック値
 */
export async function safeJsonParse<T = Record<string, unknown>>(
  response: Response,
  context: string,
  fallback: T = {} as T
): Promise<T> {
  return response.json().catch((parseError: unknown) => {
    logger.error(`[${context}] JSONパースエラー`, { status: response.status, parseError });
    return fallback;
  });
}
